import { createColumnHelper } from '@tanstack/react-table';
import { MmmCampaignDrilldownModelOutputDto } from './models/mmm-campaign-drilldown-model-output';
import {
  createCostCell,
  createCpaCell,
  createFieldCell,
  createRevenueCell,
  createRoasCell,
  createSaleCell
} from 'features/advanced-reports/table/advanced-reports-column-defs';
import { MetricTypes } from 'common/constants/metric-types';

const columnHelper = createColumnHelper<MmmCampaignDrilldownModelOutputDto>();

export const getMmmCampaignDrilldownOutputTableColumnDefs = () => {
  const columns: any[] = [
    columnHelper.accessor((row) => row.field, {
      id: 'Channel',
      header: 'Channel',
      size: 150,
      enableColumnFilter: false,
      cell: (info) =>
        createFieldCell(
          info.getValue(),
          info.row.original.id,
          info.row.original.hasChildren,
          info.row.original.shouldBlurField
        )
    }),
    columnHelper.accessor((row) => row.cost, {
      id: MetricTypes.COST,
      header: 'Spend',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createCostCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          'GBP',
          false
        )
    }),
    columnHelper.accessor((row) => row.revenue, {
      id: MetricTypes.REVENUE_VALUES,
      header: 'Revenue',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createRevenueCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          'GBP',
          false
        )
    }),
    columnHelper.accessor((row) => row.roas, {
      id: MetricTypes.ROAS,
      header: 'ROAS',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createRoasCell(
          { primaryValue: info.getValue() ?? 0, compareValue: 0 },
          false
        )
    }),
    columnHelper.accessor((row) => row.mROAS, {
      id: 'MROAS',
      header: 'MMM ROAS',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createRoasCell(
          { primaryValue: info.getValue() ?? 0, compareValue: 0 },
          false
        )
    }),
    columnHelper.accessor((row) => row.blendedMMMROAS, {
      id: 'BlendedMMMROAS',
      header: 'Blended MMM ROAS',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createRoasCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          false
        )
    }),
    columnHelper.accessor((row) => row.plannedSpend, {
      id: 'PlannedSpend',
      header: 'Planned Spend',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createCostCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          'GBP',
          false
        )
    }),
    columnHelper.accessor((row) => row.estimatedRevenue, {
      id: 'EstimatedRevenue',
      header: 'Estimated Revenue',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createRevenueCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          'GBP',
          false
        )
    }),
    columnHelper.accessor((row) => row.estimatedSales, {
      id: 'EstimatedSales',
      header: 'Estimated Sales',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createSaleCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          false
        )
    }),
    columnHelper.accessor((row) => row.cpa, {
      id: 'CPA',
      header: 'CPA',
      size: 100,
      enableColumnFilter: false,
      cell: (info) =>
        createCpaCell(
          { primaryValue: info.getValue(), compareValue: 0 },
          'GBP',
          false
        )
    })
  ];

  return columns;
};
